<template>
  <span v-if="target">
        <span v-if="'bcd' in target">
          <b-badge pill :style="'background-color: ' + 'bcd'.toHSL()">BCD</b-badge>
          {{target.bcd}}</span>
        <span v-if="'perimeter' in target"><ul>
          <li v-for="p in target.perimeter" v-bind:key="p">{{p}}</li>
        </ul></span>
  </span>
</template>

<script>

export default {
  name: 'FWMLv2TargetViz',
  props: {
    target: {
      type: Object,
      required: true
    }
  },
}
</script>
